"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
exports.default = prop_types_1.default.arrayOf(prop_types_1.default.shape({
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    disabled: prop_types_1.default.bool,
    divider: prop_types_1.default.bool,
    header: prop_types_1.default.bool,
    onSelect: prop_types_1.default.func,
}));
